import { NgIf } from '@angular/common';
import { Component, input } from '@angular/core';
import { LimitedCurrencyAmount } from '@lx/currency/shared/model/currency.model';
import { Amount } from '@lx/shared/data-access/types';
import { EqualPipe, PricePipe } from '@lx/shared/ui/pipes';

@Component({
  standalone: true,
  selector: 'lx-price-label',
  templateUrl: './price-label.component.html',
  styleUrls: ['./price-label.component.scss'],
  imports: [EqualPipe, NgIf, PricePipe],
})
export class PriceLabelComponent {
  price = input<Amount[] | LimitedCurrencyAmount[] | undefined>();
  endPrice = input<Amount | Amount[] | LimitedCurrencyAmount[] | undefined>();
  discount = input<string>('');
  disabled = input<boolean>(false);
  priceLabel = input<string>('');
  currency = input<string | undefined>();

  fromLabel = $localize`from`;
}
